import { BasicLayout, RouteView } from '@/layouts'
import { Router } from './types'

export const example: Router = {
  path: '/admin',
  name: 'admin',
  component: BasicLayout,
  meta: { title: 'menu.home' },
  redirect: '/dashboard',
  children: [
    {
      path: '/dashboard',
      name: 'dashboard',
      redirect: '/dashboard/workspace',
      component: RouteView,
      meta: { title: 'menu.dashboard.title', icon: 'bx-analyse', keepAlive: true, permission: ['admin'] },
      children: [
        {
          path: 'workspace/:pageNo([1-9]\\d*)?',
          name: 'workspace',
          component: () => import('@/views/dashboard/Workplace.vue'),
          meta: { title: 'menu.dashboard.analysis', keepAlive: false, permission: ['admin'], hidden: false }
        }
      ]
    },
    {
      path: '/account',
      component: () => import('@/views/account/index.vue'),
      name: 'account',
      meta: { title: 'menu.account.center', icon: 'bx-analyse', keepAlive: true },

    },
    /*
    {
      path: '/dragChart',
      name: 'dragChart',
      component: () => import('@/views/chart/drag.vue'),
      meta: { title: 'menu.dragChart', icon: 'bx-analyse' }
    },
    {
      path: '/makeChart',
      name: 'makeChart',
      component: () => import('@/views/chart/index.vue'),
      meta: { title: 'menu.makeChart', icon: 'bx-analyse' }
    }
      */
  ]
}
